import React from 'react'

export default function Forms () {
  return (
    <div>
      Forms
    </div>
  )
}
